import { Component, inject, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { ButtonComponent } from '@@shared/design/components/button/button.component';
import { IconComponent } from '@@shared/design/components/icon/icon.component';
import { TextButtonComponent } from '@@shared/design/components/text-button/text-button.component';

import { ConfirmationDialogData } from '../../models/confirmation-dialog.model';
import { DialogComponent } from '../dialog/dialog.component';
import { ConfirmationDialogTestIds } from './confirmation-dialog-test-id';
import { DataTestidDirective } from '@@shared/data-test-id-directive';

@Component({
	selector: 'sl-confirmation-dialog',
	templateUrl: './confirmation-dialog.component.html',
	styleUrl: './confirmation-dialog.component.scss',
	standalone: true,
	imports: [DialogComponent, DialogModule, ButtonComponent, TextButtonComponent, IconComponent, DataTestidDirective]
})
export class ConfirmationDialogComponent implements OnInit {
	content = 'Are you sure?';
	cancelButtonCaption = 'No';
	confirmButtonCaption = 'Yes';
	defaultDialogData: ConfirmationDialogData = {
		title: '',
		content: 'Are you sure?',
		cancelButtonCaption: 'No',
		confirmButtonCaption: 'Yes',
		showCancelButton: true
	};

	mergedData: ConfirmationDialogData;
	readonly dialogTestIds = ConfirmationDialogTestIds;
	readonly #dialogConfig: DynamicDialogConfig<ConfirmationDialogData> = inject(
		DynamicDialogConfig,
		{ optional: false }
	);
	readonly #dialogRef = inject(DynamicDialogRef, { optional: true });

	ngOnInit(): void {
		this.#dialogConfig.header = this.#dialogConfig.data.title;
		this.mergedData = { ...this.defaultDialogData, ...this.#dialogConfig.data };
	}

	closeDialog(value: any): void {
		this.#dialogRef.close(value);
	}
}
